<template>
	<div class="based person">
		<div v-if="data.image"
			 class="image animate-side">
			<basePicture class="static-image"
						 :image="data.image"
						 sizes="100px lg:147px xl:220px"
						 loading="eager" />
		</div>
		<div class="content">
			<div class="name text">
				<h3 class="person-name">
					{{ data.name }}
				</h3>
			</div>
			<div class="job-title text">
				<span>{{ data.role }}</span>
			</div>
			<div class="description text">
				<BaseRichText :data="data.blurb" />
			</div>
			<div v-if="data.email"
				 class="job-title text">
				<a :href="`mailto:${data.email}`"
				   class="person-email">
					<span>{{ splitEmail(data.email).first }}@</span>
					<span class="obfi">ufglvbll</span>
					<span>{{ splitEmail(data.email).second }}</span>
				</a>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	data: {
		type: Object,
		required: true
	}
})

// function splitEmail(email) {
// 	if (!email) return false
// 	const name = rot13(email.substring(0, email.lastIndexOf('@') + 1))
// 	const domain = rot13(email.substring(email.lastIndexOf('@') + 1))

// 	return { first: name, second: domain }
// }

function splitEmail(email) {
	if (!email) return false
	// const name = rot13(email.substring(0, email.lastIndexOf('@')))
	// const domain = rot13(email.substring(email.lastIndexOf('@') + 1))
	// const name = email.substring(0, email.lastIndexOf('@')).split('').reverse().join('')
	const name = email.substring(0, email.lastIndexOf('@')).split('').join('')
	const domain = email.substring(email.lastIndexOf('@') + 1)

	return { first: name, second: domain }
}
</script>
